import React from "react";
import "./GridIcon.css";

const GridIcon = ({ columns, onClick }) => {
  const blockSize = 20 / columns;

  const blocks = Array.from({ length: columns * columns }, (_, i) => (
    <div
      key={i}
      className="grid-block"
      style={{
        width: `${blockSize}px`,
        height: `${blockSize}px`,
      }}
    />
  ));

  return (
    <div
      className="d-flex flex-wrap me-2"
      style={{ width: "26px", gap: "1px" }}
      onClick={onClick}
    >
      {blocks}
    </div>
  );
};

export default GridIcon;
